// Drafting entry-point surfaces a user re-enters an existing draft from (matter overview).
// Name is intentionally generic so Phase 2 entry points (new draft, drafting hub) can extend it.
export enum DraftEntryPoint {
  RecentDraftsCarousel = 'recent_drafts_carousel',
  ChatHistoryChip = 'chat_history_chip',
}
